import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_jc8sfp728r: FaireCollectionEntity = {
  token: "pbc_jc8sfp728r",
  type: "collection",
  name: "farm",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ba86199dd6568817d9e9a7d47450ec39f21fa7e64dcfa44bae30c93857993589.jpeg",
  itemCount: 18,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:22.032Z",
    importedBy: "entity-db-import-collections",
  },
};
